// extracted by mini-css-extract-plugin
export var header = "_sf-1";
export var maskBottom = "_sf-6";
export var maskMiddle = "_sf-7";
export var maskTop = "_sf-5";
export var root = "_sf-0";
export var scrollDownButton = "_sf-3";
export var scrollDownButtonHidden = "_sf-4";
export var viewport = "_sf-2";